<template>
  <div>
    <div class="intro-y flex items-center my-3">
      <h2 class="text-lg font-medium mr-auto">New Purchase</h2>
    </div>
    <!-- <div class="grid grid-cols-12 gap-6 mt-5"> -->
    <div class="grid grid-cols-12 gap-4">
      <div class="intro-y col-span-12 lg:col-span-12">
        <!-- BEGIN: Input -->
        <div class="intro-y box p-5">
          <div id="input" class="">
            <div class="grid grid-cols-12 gap-4">
              <div class="col-span-6 sm:col-span-4 md:col-span-3 xl:col-span-2">
                <div>
                  <div class="flex items-center"><label for="update-profile-form-6" class="form-label py-0">Purchase
                      Date</label></div>
                  <div class="relative">
                    <div
                      class="absolute rounded-l w-10 h-full flex items-center justify-center bg-gray-100 border text-gray-600 dark:bg-dark-1 dark:border-dark-4">
                      <CalendarIcon class="w-4 h-4" />
                    </div>
                    <Litepicker v-model="purchase.date" :options="{
                      autoApply: false,
                      showWeekNumbers: true,
                      dropdowns: {
                        minYear: 1990,
                        maxYear: null,
                        months: true,
                        years: true
                      }
                    }" disabled class="form-control pl-12" />
                  </div>
                </div>
              </div>
              <!-- <div class="col-span-6 sm:col-span-4 md:col-span-3 xl:col-span-2">
                            <div>
                                <div class="flex items-center"><label for="update-profile-form-6" class="form-label py-0">Purchase Type</label></div>
                                <select class="form-select" v-model="purchase.type" aria-label="Default select example">
                                        <option value="makeable">Makeable</option>
                                        <option value="rough">Rough</option>
                                        <option value="video">Video</option>
                                        <option value="lab">Lab</option>
                                    </select>
                            </div>
                        </div> -->
              <div class="col-span-6 sm:col-span-4 md:col-span-3 xl:col-span-2" v-if="user_details.user_role != 3">
                <div>
                  <div class="flex items-center"><label for="update-profile-form-6"
                      class="form-label py-0">Party</label></div>
                  <TomSelect v-model="purchase.party" @change="openPiece(purchase.party)" :options="{
                    placeholder: 'Select your favorite actors'
                  }" class="w-full">
                    <!-- <option value="0">Select Party</option> -->
                    <option v-for="(party, index) in screenData.parties" :key="index" :value="party.id">{{
                      party.first_name }} {{ party.last_name }}</option>
                  </TomSelect>
                </div>
              </div>
              <div class="col-span-6 sm:col-span-4 md:col-span-3 xl:col-span-2">
                <div>
                  <div class="flex items-top"><label for="update-profile-form-6" class="form-label py-0">Kapan
                      No</label> <span class="text-primary-3"> &nbsp; *</span></div>
                  <div>

                    <div class="input-group">
                      <input type="text" class="form-control" v-model="purchase.voucher" placeholder="Kapan No"
                        @input="updateStockName" aria-describedby="input-group-4" />
                    </div>
                    <span class="text-primary-3" v-if="pagedata.errors.voucher">{{ pagedata.errors.voucher[0] }}</span>
                  </div>
                </div>
              </div>
              <div class="col-span-6 sm:col-span-4 md:col-span-3 xl:col-span-2">
                <div>
                  <div class="flex items-top"><label for="update-profile-form-6" class="form-label py-0">Select
                      Stone</label></div>
                  <select class="form-select" v-model="purchase.stone_id" @change="loadValueByStone"
                    aria-label="Default select example">
                    <option v-for="item in screenData.stones" :key="item.id" :value="item.id">{{ item.stone_name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-span-6 sm:col-span-4 md:col-span-3 xl:col-span-2">
                <div>
                  <div class="flex items-top"><label for="update-profile-form-6"
                      class="form-label py-0">Duration</label></div>
                  <div>

                    <div class="input-group mt-2 sm:mt-0">
                      <input type="text" @keypress="$h.preventInvalidInput" class="form-control" v-model="purchase.due"
                        placeholder="Duration" aria-describedby="input-group-3" />
                    </div>
                    <span class="text-primary-3" v-if="pagedata.errors.stone_id">{{ pagedata.errors.stone_id[0]
                      }}</span>
                  </div>
                </div>
              </div>
              <div class="col-span-6 sm:col-span-4 md:col-span-3 xl:col-span-2">
                <div>
                  <div class="flex items-top"><label for="update-profile-form-6" class="form-label py-0">Select
                      Type</label></div>
                  <select class="form-select" v-model="purchase.type" disabled aria-label="Default select example">
                    <option value="makeable">Makeable</option>
                    <option value="rough">Rough</option>
                  </select>
                </div>
              </div>
              <div class="col-span-6 sm:col-span-4 md:col-span-3 xl:col-span-2" v-if="pagedata.home_party == false">
                <div>
                  <div class="flex items-top"><label for="update-profile-form-6" class="form-label py-0">Est
                      Value</label></div>
                  <div>
                    <div class="input-group mt-2 sm:mt-0">
                      <input type="text" @keypress="$h.preventInvalidInput" v-model="purchase.est_majuri_total" disabled
                        class="form-control" placeholder="Est Value" aria-describedby="input-group-4" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-span-6 sm:col-span-4 md:col-span-3 xl:col-span-2" v-if="pagedata.home_party == true">
                <div>
                  <div class="flex items-top"><label for="update-profile-form-6" class="form-label py-0">Per Ct
                      Rate</label></div>
                  <div>

                    <div class="input-group">
                      <input type="text" class="form-control" @keypress="$h.preventInvalidInput"
                        v-model="purchase.per_ct_rate" disabled placeholder="Per Carat Rate ($)"
                        aria-describedby="input-group-4" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-span-6 sm:col-span-4 md:col-span-3 xl:col-span-2" v-if="pagedata.home_party == true">
                <div>
                  <div class="flex items-top"><label for="update-profile-form-6" class="form-label py-0">Total
                      Rate</label></div>
                  <div>

                    <div class="input-group">
                      <input type="text" class="form-control" @keypress="$h.preventInvalidInput"
                        v-model="purchase.total_rate" disabled placeholder="Total Rate ($)"
                        aria-describedby="input-group-4" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-span-6 sm:col-span-4 md:col-span-3 xl:col-span-2" v-if="pagedata.home_party == true">
                <div>
                  <div class="flex items-top"><label for="update-profile-form-6" class="form-label py-0">Majuri
                      Type</label></div>
                  <div>

                    <div class="input-group">
                      <select class="form-select" v-model="purchase.majuri_type" @change="getMarginCosting"
                        aria-label="Default select example">
                        <option value="1">Percent(%)</option>
                        <option value="2">Fixed</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-span-6 sm:col-span-4 md:col-span-3 xl:col-span-2" v-if="pagedata.home_party == true">
                <div>
                  <div class="flex items-top"><label for="update-profile-form-6" class="form-label py-0">Estimate
                      Majuri</label></div>
                  <div>

                    <div class="input-group mt-2 sm:mt-0">
                      <input type="text" class="form-control" @keypress="$h.preventInvalidInput"
                        v-model="purchase.majuri_rate" placeholder="Est Majuri" aria-describedby="input-group-4" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-span-6 sm:col-span-4 md:col-span-3 xl:col-span-2" v-if="pagedata.home_party == true">
                <div>
                  <div class="flex items-top"><label for="update-profile-form-6" class="form-label py-0">Estimate Margin
                      (%)</label></div>
                  <div>

                    <div class="input-group mt-2 sm:mt-0">
                      <input type="text" class="form-control" @keypress="$h.preventInvalidInput"
                        v-model="purchase.margin_percent" placeholder="Margin (%)" aria-describedby="input-group-4" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-span-6 sm:col-span-4 md:col-span-3 xl:col-span-2">
                <div>
                  <div class="flex items-top"><label for="update-profile-form-6" class="form-label py-0">No. of
                      Pieces</label></div>
                  <div>
                    <div v-if="purchase.party == '0'">

                      <div class="input-group">
                        <input type="number" class="form-control" @change="getPaketDetail" v-model="purchase.piece"
                          placeholder="No of Pieces" aria-describedby="input-group-3" disabled />
                      </div>

                    </div>
                    <div v-else>

                      <div class="input-group">
                        <input type="number" disabled class="form-control" @input="getPaketDetail"
                          v-model="purchase.piece" placeholder="No of Pieces" aria-describedby="input-group-3" />
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div class="col-span-6 sm:col-span-4 md:col-span-3 xl:col-span-2">
                <div>
                  <div class="flex items-top"><label for="update-profile-form-6" class="form-label py-0">Total
                      Weight(Ct)</label></div>
                  <div>
                    <div class="input-group">
                      <input type="number" class="form-control" disabled v-model="purchase.weight"
                        placeholder="Total Weight" aria-describedby="input-group-4" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END: Input -->

        <!-- Begin:Input Table -->
        <div class="intro-y box my-5 p-5 overflow-auto">

          <h2 class="text-lg font-medium mr-auto">Stock Details</h2>

          <table class="table border-2 pt-5">

            <thead>
              <tr class="border" v-if="purchase.type == 'rough'">
                <th>Packet No</th>
                <th>Stock No</th>
                <th>Stock Weight(Ct) <span class="text-primary-3"> &nbsp; *</span></th>
                <!-- <th>Length <span class="text-primary-3"> &nbsp; *</span></th>
                      <th>Width <span class="text-primary-3"> &nbsp; *</span></th>
                      <th>Height <span class="text-primary-3"> &nbsp; *</span></th> -->
                <!-- <th>Comment</th> -->
                <th v-if="pagedata.home_party == false">Estimate Value</th>
                <th v-if="pagedata.home_party == true">Per/Ct Rate</th>
                <th v-if="pagedata.home_party == true">Total Amount</th>
              </tr>
              <tr class="border" v-if="purchase.type == 'makeable'">
                <th>Packet No</th>
                <th>Stock No</th>
                <th>Stock Weight(Ct) <span class="text-primary-3"> &nbsp; *</span></th>
                <th>Polish Weight(Ct) <span class="text-primary-3"> &nbsp; *</span></th>
                <th>Shape <span class="text-primary-3"> &nbsp; *</span></th>
                <th>Color <span class="text-primary-3"> &nbsp; *</span></th>
                <th>Purity <span class="text-primary-3"> &nbsp; *</span></th>
                <th>Cut <span class="text-primary-3"> &nbsp; *</span></th>
                <th>Polish <span class="text-primary-3"> &nbsp; *</span></th>
                <th>Symm <span class="text-primary-3"> &nbsp; *</span></th>
                <th>Fluc <span class="text-primary-3"> &nbsp; *</span></th>
                <th>TN <span class="text-primary-3"> &nbsp; *</span></th>
                <th>Discount(%) <span class="text-primary-3"> &nbsp; *</span></th>
                <th>Rapo Rate <span class="text-primary-3"> &nbsp; *</span></th>
                <th>Rate <span class="text-primary-3"> &nbsp; *</span></th>
                <th v-if="pagedata.home_party == false">Estimate Value</th>
                <th v-if="pagedata.home_party == true">Per/Ct Rate</th>
                <th v-if="pagedata.home_party == true">Total Amount</th>
              </tr>
            </thead>
            <tbody class="border" v-if="purchase.type == 'rough'">

              <tr class="" v-for="(item, index) in purchase.packet_details" :key="index">
                <td class="whitespace-nowrap border-b">
                  <div v-if="route.params.id">
                    <div class="" v-if="item.number">{{ item.number }}</div>
                    <div class="" v-else>
                      <div v-if="index < 9">{{ purchase.lotno }}-0{{ index + 1 }}</div>
                      <div v-else>{{ purchase.lotno }}-{{ index + 1 }}</div>
                    </div>
                  </div>
                  <div v-else>
                    <div class=" " v-if="index < 9">XX-XX-0{{ index + 1 }}</div>
                    <div class="" v-else>XX-XX-{{ index + 1 }}</div>
                  </div>
                </td>
                <!-- <td class="whitespace-nowrap" style="padding: 2px;"><input type="text" v-model="item.paket_no" class="form-control rounded-none w-24" placeholder="Stock No" aria-describedby="input-group-3" disabled /></td> -->
                <td class="whitespace-nowrap" style="padding: 2px;" v-if="purchase.party != 1"><input type="text"
                    v-model="item.paket_no" @change="validateStockNo(item, index)"
                    class="form-control rounded-none w-24" placeholder="Stock No" aria-describedby="input-group-3" />
                </td>
                <td class="whitespace-nowrap border-b" v-else style="padding: 2px;">
                  {{ item.id ? item.paket_no : (item.paket_no + (index + 1)) }}
                </td>
                <td class="whitespace-nowrap" style="padding: 2px;"><input type="text"
                    @input="calculateTotalValue(item, 'weight')" v-model="item.weight" class="form-control rounded-none"
                    @keypress="$h.preventInvalidInput" placeholder="Weight(Ct)" aria-describedby="input-group-3" /></td>
                <!-- <td class="whitespace-nowrap" style="padding: 2px;"><input type="text" v-model="item.length" class="form-control rounded-none" @keypress="$h.preventInvalidInput" placeholder="Length" aria-describedby="input-group-3" /></td>
                    <td class="whitespace-nowrap" style="padding: 2px;"><input type="text" v-model="item.width" class="form-control rounded-none" @keypress="$h.preventInvalidInput" placeholder="Width" aria-describedby="input-group-3" /></td>
                    <td class="whitespace-nowrap" style="padding: 2px;"><input type="text" v-model="item.height" class="form-control rounded-none" @keypress="$h.preventInvalidInput" placeholder="Height" aria-describedby="input-group-3" /></td> -->
                <!-- <td class="whitespace-nowrap" style="padding: 2px;"><input type="text" v-model="item.comment" class="form-control rounded-none" placeholder="Comment" aria-describedby="input-group-3" /></td> -->
                <td class="whitespace-nowrap" style="padding: 2px;" v-if="pagedata.home_party == false"><input type="text" v-model="item.est_majuri"
                    disabled class="form-control rounded-none" placeholder="Est Value"
                    aria-describedby="input-group-3" /></td>
                <td class="whitespace-nowrap" style="padding: 2px;" v-if="pagedata.home_party == true"><input type="text" v-model="item.owner_per_ct"
                    @input="calculateTotalValue(item, 'owner_per_ct')" class="form-control rounded-none" placeholder="Price Per/Ct"
                    aria-describedby="input-group-3" /></td>
                <td class="whitespace-nowrap" style="padding: 2px;" v-if="pagedata.home_party == true"><input type="text" v-model="item.owner_value"
                    disabled class="form-control rounded-none" placeholder="Total Amount"
                    aria-describedby="input-group-3" /></td>
                <td class="whitespace-nowrap" style="padding: 2px;"><button type="button"
                    class="text-theme-6 flex items-center" tabindex="-1" v-if="!item.id"
                    @click="removeField(item.id, index)">
                    <Trash2Icon class="w-5 h-5 mr-1" tabindex="-1" />
                  </button></td>
              </tr>

            </tbody>
            <tbody class="border" v-if="purchase.type == 'makeable'">

              <tr class="" v-for="(item, index) in purchase.packet_details" :key="index">
                <td class="whitespace-nowrap border-b">
                  <div v-if="route.params.id">
                    <div class="" v-if="item.number">{{ item.number }}</div>
                    <div class="" v-else>
                      <div v-if="index < 9">{{ purchase.lotno }}-0{{ index + 1 }}</div>
                      <div v-else>{{ purchase.lotno }}-{{ index + 1 }}</div>
                    </div>
                  </div>
                  <div v-else>
                    <div class=" " v-if="index < 9">XX-XX-0{{ index + 1 }}</div>
                    <div class="" v-else>XX-XX-{{ index + 1 }}</div>
                  </div>
                </td>
                <td class="whitespace-nowrap" style="padding: 2px;" v-if="purchase.party != 1"><input type="text"
                    v-model="item.paket_no" @change="validateStockNo(item, index)"
                    class="form-control rounded-none w-24" placeholder="Stock No" aria-describedby="input-group-3" />
                </td>
                <td class="whitespace-nowrap border-b" v-else style="padding: 2px;">
                  {{ item.id ? item.paket_no : (item.paket_no + (index + 1)) }}
                </td>
                <!-- <td class="whitespace-nowrap border-b" style="padding: 2px;">
                      {{ item.id ? item.paket_no : (item.paket_no + (index + 1)) }}
                    </td> -->
                <td class="whitespace-nowrap" style="padding: 2px;"><input type="text" v-model="item.weight"
                    @input="calculateTotalValue(item, 'weight')" class="form-control rounded-none w-28" @keypress="$h.preventInvalidInput" placeholder="Weight(Ct)"
                    aria-describedby="input-group-3" /></td>
                <td class="whitespace-nowrap" style="padding: 2px;"><input type="text" @input="loadPlanningValues(item)"
                    v-model="item.polish_weight" class="form-control rounded-none w-28"
                    @keypress="$h.preventInvalidInput" placeholder="Polish(Ct)" aria-describedby="input-group-3" /></td>
                <td class="whitespace-nowrap" style="padding: 2px;">
                  <select class="form-select" v-model="item.shape" @change="loadPlanningValues(item)"
                    aria-label="Default select example">
                    <option v-for="item in screenData.shapes" :key="item.id" :value="item.id">{{ item.shape_name }}
                    </option>
                  </select>
                </td>
                <td class="whitespace-nowrap" style="padding: 2px;">
                  <select class="form-select" v-model="item.color" @change="loadPlanningValues(item)"
                    aria-label="Default select example">
                    <option v-for="item in screenData.colors" :key="item.id" :value="item.id">{{ item.color_name }}
                    </option>
                  </select>
                </td>
                <td class="whitespace-nowrap" style="padding: 2px;">
                  <select class="form-select" v-model="item.purity" @change="loadPlanningValues(item)"
                    aria-label="Default select example">
                    <option v-for="item in screenData.purities" :key="item.id" :value="item.id">{{ item.purity_name }}
                    </option>
                  </select>
                </td>
                <td class="whitespace-nowrap" style="padding: 2px;">
                  <select class="form-select" v-model="item.cut" @change="loadPlanningValues(item)"
                    aria-label="Default select example">
                    <option v-for="item in screenData.cuts" :key="item.id" :value="item.id">{{ item.cut_name }}</option>
                  </select>
                </td>
                <td class="whitespace-nowrap" style="padding: 2px;">
                  <select class="form-select" v-model="item.polish" @change="loadPlanningValues(item)"
                    aria-label="Default select example">
                    <option v-for="item in screenData.polish" :key="item.id" :value="item.id">{{ item.polish_name }}
                    </option>
                  </select>
                </td>
                <td class="whitespace-nowrap" style="padding: 2px;">
                  <select class="form-select" v-model="item.symmetry" @change="loadPlanningValues(item)"
                    aria-label="Default select example">
                    <option v-for="item in screenData.symmetry" :key="item.id" :value="item.id">{{ item.symmetry_name }}
                    </option>
                  </select>
                </td>
                <td class="whitespace-nowrap" style="padding: 2px;">
                  <select class="form-select" v-model="item.fluerocent" @change="loadPlanningValues(item)"
                    aria-label="Default select example">
                    <option v-for="item in screenData.fluerocents" :key="item.id" :value="item.id">{{
                      item.fluerocent_name }}</option>
                  </select>
                </td>
                <td class="whitespace-nowrap" style="padding: 2px;">
                  <select class="form-select" v-model="item.tension" @change="loadPlanningValues(item)"
                    aria-label="Default select example">
                    <option v-for="item in screenData.tensions" :key="item.id" :value="item.id">{{ item.tension_name }}
                    </option>
                  </select>
                </td>
                <td class="whitespace-nowrap" style="padding: 2px;"><input type="text" v-model="item.discount"
                    class="form-control rounded-none w-24" @keypress="$h.preventInvalidInput"
                    @input="calculateValue(item)" placeholder="Discount" aria-describedby="input-group-3" /></td>
                <td class="whitespace-nowrap" style="padding: 2px;"><input type="text" disabled v-model="item.rap_value"
                    class="form-control rounded-none w-24" @keypress="$h.preventInvalidInput" placeholder="Rapo rate"
                    aria-describedby="input-group-3" /></td>
                <td class="whitespace-nowrap" style="padding: 2px;"><input type="text" disabled v-model="item.value"
                    class="form-control rounded-none w-24" placeholder="Value" aria-describedby="input-group-3" /></td>
                <td class="whitespace-nowrap" style="padding: 2px;" v-if="pagedata.home_party == false"><input type="text" v-model="item.est_majuri"
                    disabled class="form-control rounded-none" placeholder="Est Value"
                    aria-describedby="input-group-3" /></td>
                <td class="whitespace-nowrap" style="padding: 2px;" v-if="pagedata.home_party == true"><input type="text" v-model="item.owner_per_ct"
                    @input="calculateTotalValue(item, 'owner_per_ct')" class="form-control rounded-none" placeholder="Price Per/Ct"
                    aria-describedby="input-group-3" /></td>
                <td class="whitespace-nowrap" style="padding: 2px;" v-if="pagedata.home_party == true"><input type="text" v-model="item.owner_value"
                    disabled class="form-control rounded-none" placeholder="Total Amount"
                    aria-describedby="input-group-3" /></td>
                <td class="whitespace-nowrap" style="padding: 2px;"><button type="button"
                    class="text-theme-6 flex items-center" tabindex="-1" v-if="!item.id"
                    @click="removeField(item.id, index)">
                    <Trash2Icon class="w-5 h-5 mr-1" tabindex="-1" />
                  </button></td>
              </tr>

            </tbody>
          </table>

          <div class="flex justify-between">

            <div>
              <div class="text-left">
                <button type="button" @click="AddPiece" class="btn btn-primary w-24">Add Piece</button>
              </div>
            </div>
            <div>
              <div class="flex justify-end align-items-center mt-5">
                <router-link :to="{ name: 'purchase-view' }" class="btn btn-outline-secondary w-24 mr-1">
                  Cancel
                </router-link>
                <div class="text-left">
                  <button type="button" @click="SavePurchase" :disabled="pagedata.submit"
                    class="btn btn-primary w-24">Save
                    <LoadingIcon v-if="pagedata.submit" icon="oval" color="white" class="w-4 h-4 ml-2" />
                  </button>
                </div>
              </div>
            </div>
          </div>


        </div>
        <!-- End:Input Table -->
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>

<script setup>
/* eslint-disable */
import {
  BASE_URL
} from '@/constants/config'
import router from '@/router'
import axios from 'axios'
import {
  computed,
  defineComponent,
  inject,
  onMounted,
  reactive,
  ref,
  watch
} from 'vue'
import moment from 'moment'
import {
  useRoute
} from 'vue-router'
import store from '@/store'
import {
  stringify
} from 'json5'
import {
  helper as $h
} from '@/utils/helper'
const route = useRoute()
const screenData = reactive({
  parties: [],
  colors: [],
  cuts: [],
  purities: [],
  symmetry: [],
  polish: [],
  fluerocents: [],
  tensions: [],
  stones: [],
  shapes: [],
  labs: [],
})
const swal = inject('$swal')

const user_details = computed(() => store.state.user.currentUser)

const pagedata = reactive({
  paket_num: 0,
  btnDis: false,
  btnPrev: true,
  submit: false,
  home_party: (user_details.value.home_party == 1) ? true : false,
  errors: [],
})

const purchase = reactive({
  ip: localStorage.getItem('sk_key'),
  id: '',
  party: '0',
  purchase_party: '0',
  diamond_type: '0',
  stone_id: 2,
  piece: '',
  cr_piece: '',
  type: 'rough',
  weight: '',
  due: 15,
  voucher: '',
  lotno: '',
  per_ct_rate: '',
  total_rate: '',
  majuri_type: '2',
  majuri_rate: '',
  margin_percent: '',
  ls_loss_per: '',
  purchase_type: '1',
  packet_details: []
})

function SavePurchase() {
  pagedata.submit = true;

  if (purchase.party === '0') return;

  let submit = true;


  if (!submit) return;

  getWeight();

  // Prepare purchase date
  purchase.date = moment(purchase.date).format('YYYY-MM-DD');

  // Submit purchase via Axios
  axios({
    url: '/api/purchase/add_lot_socks_by_purchase',
    method: 'post',
    baseURL: BASE_URL,
    data: purchase,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token'),
      Accept: 'application/json'
    }
  })
    .then(res => {
      pagedata.submit = false;

      if (res.data.status === 'error') {
        swal("Warning!", res.data.message, "warning");
      } else {
        router.push({ name: 'purchase-view' });
      }
    })
    .catch(err => {
      pagedata.submit = false;
      swal("Warning!", err.response?.data?.error || "Something went wrong", "warning");
    });
}

function openPiece(id) {
  const party = screenData.parties.find(p => p.id === id);

  if (party) {
    pagedata.home_party = (party.home_party == 1);
    getPaketDetail();
  }
}

function prevnext(type) {
  if (type == 'next') {
    // if(validateData()) {
    pagedata.paket_num = pagedata.paket_num + 1;
    // }
  } else if (type == 'prev') {
    pagedata.paket_num = pagedata.paket_num - 1;
  }
  getPaketDetail()
}

function getWeight() {
  // Sum total weight
  purchase.weight = $h.myFloat(
    purchase.packet_details.reduce((total, element) =>
      total + parseFloat(element.weight || 0), 0)
  );
}

function loadPlanningValues(plan) {
  if (parseFloat(plan.polish_weight) > parseFloat(plan.weight)) {
    plan.polish_weight = ''
    swal("Warning!", "Polish Weight Should Be Less then Issue Weight!", "warning");
  }
  if (plan.polish_weight != '' && plan.color != '' && plan.purity != '' && plan.shape != '') {

    var i = screenData.shapes.length;
    let plan_shape = ''
    while (i--) {
      if (screenData.shapes[i]['id'] == plan.shape) {
        plan_shape = screenData.shapes[i]['shape_group']
      }
    }
    let params = {
      color: plan.color,
      purity: plan.purity,
      shape: plan.shape,
      shape_group: plan_shape,
      polish_weight: plan.polish_weight
    }
    axios({
      url: 'api/plan/get_plan_rapo',
      method: 'post',
      baseURL: BASE_URL,
      data: params,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
      config: {
        headers: {
          'Accept': 'application/json'
        }
      }
    }).then((res) => {
      plan.rap_value = $h.myFloat(res.data.rape_value * plan.polish_weight)
      calculateValue(plan)
    })
  }
  if (plan.polish_weight != '' && plan.color != '' && plan.purity != '' && plan.shape != '' && plan.cut != '' && plan.polish != '' && plan.symmetry != '' && plan.fluerocent != '' && plan.tension != '' && purchase.stone_id != '') {

    let value_params = {
      polish_weight: plan.polish_weight,
      color: plan.color,
      cut: plan.cut,
      purity: plan.purity,
      polish: plan.polish,
      shape: plan.shape,
      symmetry: plan.symmetry,
      fluerocent: plan.fluerocent,
      tension: plan.tension,
      stone: purchase.stone_id,
      type: purchase.type,
      party_id: purchase.party,
    }

    axios({
      url: 'api/plan/get_makeable_purchase_value',
      method: 'post',
      baseURL: BASE_URL,
      data: value_params,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
      config: {
        headers: {
          'Accept': 'application/json'
        }
      }
    }).then((res) => {
      plan.est_majuri = res.data.majuri_value * plan.weight
      calculateEstMajuriDetails()
    })
  }

}

function calculateEstMajuriDetails() {
  purchase.est_majuri_total = $h.myFloat(
    purchase.packet_details.reduce(
      (total, element) => total + $h.myFloat(element.est_majuri || 0),
      0
    )
  );
}


function loadValueByStone() {
  const { packet_details, stone_id, type, party } = purchase

  if (!packet_details?.length) return

  axios.post(
    'api/plan/get_stone_change_purchase_value',
    {
      packet_details,
      stone: stone_id,
      type,
      party_id: party,
    },
    {
      baseURL: BASE_URL,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        Accept: 'application/json',
      },
    }
  ).then(({ data }) => {
    const rates = data.items || []

    purchase.packet_details.forEach((packet, index) => {
      packet.est_majuri = (rates[index] || 0) * packet.weight
    })

    calculateEstMajuriDetails()
  }).catch(err => {
    console.error('Stone value load failed:', err)
  })
}


function calculateValue(plan) {
  let rap_value = plan.rap_value
  let discount = plan.discount

  if (rap_value && discount) {
    let value = parseFloat(rap_value) * parseFloat(100 - discount) / 100
    plan.value = value
  }
}
const updateStockName = () => {
  if (!purchase.piece || !purchase.packet_details) return;

  purchase.packet_details.forEach((value, index) => {
    value.paket_no = purchase.voucher
      ? `${purchase.voucher}_${index + 1}`
      : '';
  });
};




const validateStockNo = (packet, index) => {
  const packet_no = packet.paket_no;

  // Check if the packet_no exists in other packet details
  const packet_no_exist = purchase.packet_details.some((item, inx) =>
    item.paket_no === packet_no && inx !== index
  );

  if (packet_no_exist) {
    packet.paket_no = '';
    return false;
  }
};



function removeField(id, index) {
  swal({
    title: "Are you sure?",
    text: "You are about to delete a item!",
    type: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Delete",
    showLoaderOnConfirm: true,
    cancelButtonText: "Cancel",

    allowOutsideClick: () => !$Swal.isLoading()
  }).then(result => {
    if (result.isConfirmed) {
      var i = purchase.packet_details.length;
      while (i--) {
        if (i == index) {
          purchase.packet_details.splice(i, 1);
        }
      }
      calculateEstMajuriDetails()
      getWeight()
    }
  });
}

const AddPiece = () => {
  purchase.packet_details.push({
    paket_no: (purchase.voucher && purchase.party == 1 ? (purchase.voucher + '-') : ''),
    number: '',
    weight: '',
    est_majuri: '',
    polish_weight: '',
    color: '',
    purity: '',
    shape: '',
    cut: '',
    polish: '',
    symmetry: '',
    fluerocent: '',
    tension: '',
    stone: '',
    lab: '',
    certificate_no: '',
    rap_value: '',
    min_dia1: '',
    min_dia2: '',
    total_depth: '',
    depth_percent: '',
    table_percent: '',
    length: '',
    width: '',
    height: '',
    comment: '',
    owner_per_ct: purchase.per_ct_rate,
    owner_value: '',
    value: '',
    discount: 30,
    processing: 'normal'
  })
}



const getParties = () => {
  axios({
    url: 'api/master/dp_parties',
    method: 'post',
    baseURL: BASE_URL,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    config: {
      headers: {
        'Accept': 'application/json'
      }
    }
  }).then((res) => {
    screenData.parties = res.data.items
    if (route.params.id) {
      setHomeParty()
    } else {
      purchase.party = String(screenData.parties[0].id)
    }
  })
}

const getMarginCosting = () => {
  const params = {
    type: window.btoa(purchase.majuri_type)
  }
  axios({
    url: 'api/majuri_costing/get_party_majuri_costing',
    method: 'post',
    baseURL: BASE_URL,
    data: params,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    config: {
      headers: {
        'Accept': 'application/json'
      }
    }
  }).then((res) => {
    purchase.majuri_rate = res.data.majuri_value.value
    purchase.margin_percent = res.data.margin_value.value
  })
}

const get_all_parameters = () => {
  axios({
    url: 'api/master/get_all_parameters',
    method: 'post',
    baseURL: BASE_URL,
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token')
    },
    config: {
      headers: {
        'Accept': 'application/json'
      }
    }
  }).then((res) => {
    screenData.colors = res.data.color
    screenData.cuts = res.data.cut
    screenData.purities = res.data.purity
    screenData.polish = res.data.polish
    screenData.shapes = res.data.shape
    screenData.symmetry = res.data.symmetry
    screenData.fluerocents = res.data.fluerocent
    screenData.tensions = res.data.tension
    screenData.stones = res.data.stone
    screenData.labs = res.data.lab

  })
}

const getPurchaseData = () =>  {
  purchase.piece = 0;

  axios({
    url: 'api/purchase/show_purchase',
    method: 'post',
    baseURL: BASE_URL,
    data: { id: purchase.id },
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('token'),
      Accept: 'application/json'
    }
  })
    .then(res => {
      const data = res.data.purchase;
      purchase.party = String(data.party_id)
      purchase.purchase_party = String(data.purchase_party)
      purchase.diamond_type = String(data.diamond_type)
      purchase.type = data.type
      purchase.stone_id = data.stone_type
      purchase.piece = data.pr_pcs
      purchase.cr_piece = data.cr_pcs
      purchase.weight = data.pr_wt
      purchase.due = data.due
      purchase.voucher = data.voucher_no
      purchase.lotno = data.lot_no
      purchase.per_ct_rate = data.per_ct_rate
      purchase.total_rate = data.total_rate
      purchase.majuri_rate = data.majuri_rate
      purchase.margin_percent = data.margin_percent
      purchase.ls_loss_per = data.ls_loss_per
      purchase.purchase_type = String(data.purchase_type)

      let packets = res.data.packets;


      if(packets.length > 0) {

        // Map packets to purchase.packet_details
        purchase.packet_details = packets.map(pkt => ({
          id: pkt.id,
          number: pkt.number,
          paket_no: pkt.vepari_no,
          weight: pkt.weight,
          polish_weight: pkt.cr_polish_weight,
          color: pkt.color,
          purity: pkt.purity,
          shape: pkt.shape,
          cut: pkt.cut,
          polish: pkt.polish,
          symmetry: pkt.symmetry,
          fluerocent: pkt.fluerocent,
          tension: pkt.tension,
          stone: pkt.stone,
          discount: pkt.discount,
          processing: pkt.processing,
          lab: pkt.lab,
          certificate_no: pkt.cert_no,
          rap_value: pkt.rap_value,
          value: pkt.value,
          min_dia1: pkt.min_dia1,
          min_dia2: pkt.min_dia2,
          total_depth: pkt.total_depth,
          depth_percent: pkt.depth_percent,
          table_percent: pkt.table_percent,
          length: pkt.length,
          width: pkt.width,
          height: pkt.height,
          comment: pkt.comment,
          owner_per_ct: pkt.owner_per_ct,
          owner_value: pkt.owner_value,
          est_majuri: pkt.est_value
        }));
      }
      addEmptyPackets();

      openPiece(purchase.party);

      getWeight();

      setHomeParty();
    })
    .catch(() => {
      router.push({ name: 'purchase-view' });
    });
}

const setHomeParty = () => {

  if((purchase.party > 0) && (screenData.parties.length > 0)) {

    const party = screenData.parties.find(
      element => element.id == purchase.party
    );

    pagedata.home_party = party && party.home_party ? true : false;
  }
};

onMounted(() => {
  get_all_parameters()
  getParties()

  if (user_details.value.user_role == 3) {
    purchase.party = user_details.value.account_id
  }
  if (route.params.id) {
    purchase.id = route.params.id
    getPurchaseData()
  } else {
    getMarginCosting()
  }
})

const addEmptyPackets = () => {

  const curr = purchase.cr_piece;

  // If increased, add new packet_details
  if (curr > purchase.packet_details.length) {
    for (let i = purchase.packet_details.length; i < curr; i++) {
      purchase.packet_details.push({
        paket_no:
          purchase.voucher && purchase.party == 1
            ? `${purchase.voucher}-`
            : '',
        number: '',
        weight: '',
        est_majuri: '',
        polish_weight: '',
        color: '',
        purity: '',
        shape: '',
        cut: '',
        polish: '',
        symmetry: '',
        fluerocent: '',
        tension: '',
        stone: '',
        lab: '',
        certificate_no: '',
        rap_value: '',
        min_dia1: '',
        min_dia2: '',
        total_depth: '',
        depth_percent: '',
        table_percent: '',
        length: '',
        width: '',
        height: '',
        comment: '',
        owner_per_ct: purchase.per_ct_rate,
        owner_value: '',
        value: '',
        discount: 30,
        processing: 'normal',
      });
    }

  }
}

const calculateTotalValue = (item, type) => {

  if(type == "weight" && (pagedata.home_party == false)) {

    let value_params = {
      weight: item.weight,
      stone: purchase.stone_id,
      type: purchase.type,
      party_id: purchase.party,
    }

    axios({
      url: 'api/plan/get_rough_purchase_value',
      method: 'post',
      baseURL: BASE_URL,
      data: value_params,
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
      config: {
        headers: {
          'Accept': 'application/json'
        }
      }
    }).then((res) => {
      item.est_majuri = res.data.majuri_value * item.weight
      calculateEstMajuriDetails()
    })

  }

  if(pagedata.home_party == true) {

    console.log("Purchase Value will Updated")
    if(item.weight > 0 && item.owner_per_ct > 0) {
      console.log("Purchase Value Updated")
      item.owner_value = parseFloat(item.weight * item.owner_per_ct).toFixed(2);
      console.log(item.owner_value)
    } else {
      item.owner_value = '';
    }
  }
}
</script>
